import { render, staticRenderFns } from "./ChangeCategorie.vue?vue&type=template&id=028ab273&"
import script from "./ChangeCategorie.vue?vue&type=script&lang=js&"
export * from "./ChangeCategorie.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports